import script from "./FormularioRegistroFinanceiro.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioRegistroFinanceiro.vue?vue&type=script&setup=true&lang=js"

import "./FormularioRegistroFinanceiro.vue?vue&type=style&index=0&id=6b491e78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b491e78"]])

export default __exports__